"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TimeLine = _interopRequireDefault(require("./TimeLine.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default2 = exports.default = {
  name: 'TimeLineProtocolLife',
  components: {
    TimeLine: _TimeLine.default
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
};